import axios from "axios";
import { convertSHA } from "./ExtracurricularCoursesToken";
import {
  certificateFilename,
  parseCertificateApiPayload,
} from "../../views/payroll/utils/certificateData";

export const SEND_CERTIFICATE = "SEND_CERTIFICATE";
export const CER_LOADING = "CER_LOADING";
export const VERIF_SANITARIO = "VERIF_SANITARIO";
export const SEND_SANITARIO = "SEND_SANITARIO";
export const DOWNLOAD_CERTIFICATE = "DOWNLOAD_CERTIFICATE";
export const CERTIFICATE_DOWNLOAD_ERROR = "CERTIFICATE_DOWNLOAD_ERROR";
export const CERTIFICATE_API_NO_PDF = "CERTIFICATE_API_NO_PDF";

const instance = axios.create({
  baseURL: process.env.REACT_APP_AYB_API_CER_URL,
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods":
      "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "content-type": "application/json",
  },
});

const CERTIFICADOS_PATH =
  "/certificados?code=jqMWm9nF6EosjYak47tXUb/IA/XD81I2hU6wXs7nJcmcMceW3zGdWg==";

function formatDate(date) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
}

function buildCertificatePayload(badge, certificateType) {
  const fecha = formatDate(Date());
  return {
    codigo_certificado: certificateType,
    codigo_empleado: badge,
    fecha_documento: fecha,
    ciudad: " San Jose",
    fecha_ini_incapacidad: fecha,
    codemp_firma: badge,
  };
}

async function blobLooksLikePdf(blob) {
  if (!blob || blob.size < 4) return false;
  const header = await blob.slice(0, 4).text();
  return header.startsWith("%PDF");
}

function triggerBlobDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function base64ToBlob(base64, mime = "application/pdf") {
  const raw = base64.includes(",") ? base64.split(",")[1] : base64;
  const binary = atob(raw);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
}

async function parseJsonBlob(blob) {
  try {
    const text = await blob.text();
    return JSON.parse(text);
  } catch {
    return null;
  }
}

async function tryParseJsonPdf(blob) {
  const json = await parseJsonBlob(blob);
  if (!json) return null;
  const b64 =
    json.file ||
    json.pdf ||
    json.base64 ||
    json.contenido ||
    json.documento;
  if (typeof b64 === "string" && b64.length > 100) {
    return base64ToBlob(b64);
  }
  return null;
}

/**
 * POST certificados with blob response. Returns { source: 'api' } if PDF downloaded,
 * { source: 'client' } if caller should build PDF client-side.
 */
export const downloadCertificate = (badge, certificateType) => {
  const params = buildCertificatePayload(badge, certificateType);
  const filename = certificateFilename(certificateType);

  return async (dispatch) => {
    dispatch({ type: CER_LOADING, certificateType });

    try {
      const res = await instance.post(CERTIFICADOS_PATH, params, {
        responseType: "blob",
        headers: { "content-type": "application/json" },
      });

      let blob = res.data;
      const contentType = (res.headers["content-type"] || "").toLowerCase();

      if (
        contentType.includes("application/pdf") ||
        (await blobLooksLikePdf(blob))
      ) {
        if (!blob.type) {
          blob = new Blob([blob], { type: "application/pdf" });
        }
        triggerBlobDownload(blob, filename);
        dispatch({ type: DOWNLOAD_CERTIFICATE, certificateType });
        return { source: "api" };
      }

      const json = await parseJsonBlob(blob);
      if (json) {
        const b64 =
          json.file ||
          json.pdf ||
          json.base64 ||
          json.contenido ||
          json.documento;
        if (typeof b64 === "string" && b64.length > 100) {
          triggerBlobDownload(base64ToBlob(b64), filename);
          dispatch({ type: DOWNLOAD_CERTIFICATE, certificateType });
          return { source: "api" };
        }
      }

      const apiData = json ? parseCertificateApiPayload(json) : null;
      dispatch({ type: CERTIFICATE_API_NO_PDF, certificateType });
      return { source: "client", apiData };
    } catch (error) {
      console.log("Certificate download error", error);
      dispatch({
        type: CERTIFICATE_DOWNLOAD_ERROR,
        certificateType,
        error: error.message,
      });
      throw error;
    }
  };
};

export const sendCertificate = (badge, cetificate) => {
  const params = buildCertificatePayload(badge, cetificate);

  const config = {
    headers: { "content-type": "application/json" },
  };
  return async (dispatch) => {
    dispatch({
      type: CER_LOADING,
    });
    await instance
      .post(CERTIFICADOS_PATH, params, config)
      .then((res) => {
        dispatch({
          type: SEND_CERTIFICATE,
          data: res.data,
        });
        console.log(res);
      })
      .catch(function (error) {
        console.log("Error", error);
      });
  };
};

export const VerifSanitario = (badge) => {
  const config = { headers: { "content-type": "application/json" } };
  const Token = convertSHA();
  return async (dispatch) => {
    dispatch({
      type: CER_LOADING,
    });
    await axios
      .get(
        `https://sykesappscr.com/APICertificados/revision-sanitario?legajo=${badge}&token=${Token}`,
        config
      )
      .then((res) => {
        dispatch({
          type: VERIF_SANITARIO,
          data: res.data,
        });
        console.log(res);
      })
      .catch(function (error) {
        console.log("Error", error);
      });
  };
};

export const SendSanitario = (badge, email) => {
  const config = { headers: { "content-type": "application/json" } };
  const Token = convertSHA();
  return async (dispatch) => {
    dispatch({
      type: CER_LOADING,
    });
    await axios
      .get(
        `https://sykesappscr.com/APICertificados/certificado-sanitario?legajo=${badge}&email=${email}&token=${Token}`,
        config
      )
      .then((res) => {
        dispatch({
          type: SEND_SANITARIO,
          data: res.data,
        });
        console.log(res);
      })
      .catch(function (error) {
        console.log("Error", error);
      });
  };
};
